
	import { Component, Vue } from 'vue-property-decorator';

	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import analyticsModule from '@/HostApp/services/Analytics/AnalyticsModule';
	import systemLayoutModule from '@/HostApp/services/SystemLayout/SystemLayoutModule';
	import { serverProps } from '@/Common/Environment/const';
	import { computed, watch } from 'vue';

	const bottomItems: Array<string> = [
		'http://cbs/appstore#appstore', // CB Store common
		'http://cbs/appstore#appstore-provider', // CB Store for providers
		'http://aps-standard.org/branding-ui#settings-ux1' // Settings application
	];

	enum MenuStates {
		Collapsed = 'Collapse',
		Expanded = 'Expand'
	}

	@Component({
		components: {}
	})
	export default class TheSideBar extends Vue {
		protected state: APS.IServerProps = serverProps;
		protected sideBarItemLoading: string = '';

		/** todo @a.bondar scroll into view after menuIndex changing **/

		protected get isShowLeftMenu(): boolean {
			return this.state.isShowLeftMenu;
		}

		protected get isMenuCollapsed(): boolean {
			return aps.navigation.isMenuCollapsed;
		}

		protected set isMenuCollapsed(value: boolean) {
			aps.navigation.isMenuCollapsed = value;
		}

		protected get currentMenuItemId(): string | undefined {
			return aps.navigation.currentMenuItemId;
		}

		protected get menuItems(): Array<APS.ISideMenuItem> {
			return aps.navigation.sideMenuItems;
		}

		protected get viewParams(): APS.IViewParams {
			return this.state.viewParams;
		}

		protected get copyrights(): APS.ICopyrights | undefined {
			const { _copyright: copyrights } = aps.context;

			return copyrights
				? {
						show: copyrights.show,
						text: copyrights.text.replace('&#169;', '©'),
						link: copyrights.link
				  }
				: undefined;
		}

		protected get screenSize(): LAYOUT.ScreenBreakpoints {
			return systemLayoutModule.screenSize;
		}

		protected created(): void {
			const { navigation } = window.aps;
			this.isMenuCollapsed = window.localStorage.getItem('ux1SidebarMenuCollapsed') === 'true';

			watch(
				() => computed(() => navigation.tree?.items).value,
				(value) => value && window.aps.navigation.updateSideMenuItems(value),
				{ immediate: true }
			);

			watch(
				() => computed(() => navigation.vueWorkspace).value,
				(value) => navigation.onWorkspaceChange(!!value),
				{ immediate: true }
			);
		}

		protected async handleSubmenuOpened(itemId: string): Promise<void> {
			if (!aps.navigation.loadedSubmenu.get(itemId) && this.isMenuCollapsed) {
				this.sideBarItemLoading = itemId;

				await aps.navigation.getNavigationResponse(itemId);

				this.sideBarItemLoading = '';
			}
		}

		protected handleItemChange(item: APS.INavigationTreeItem): void {
			aps.navigation.doNavigation(item);
		}

		protected get mainMenuItems(): Array<APS.ISideMenuItem> {
			return this.menuItems.filter((item) => !bottomItems.includes(item.id));
		}

		protected get bottomMenuItems(): Array<APS.ISideMenuItem> {
			return this.menuItems.filter((item) => bottomItems.includes(item.id));
		}

		protected onMenuCollapsedChange(): void {
			this.isMenuCollapsed = !this.isMenuCollapsed;

			analyticsModule.pushHostGAData({
				event: 'NE collapse menu',
				eventCategory: 'NE collapse menu',
				eventAction: this.isMenuCollapsed ? MenuStates.Collapsed : MenuStates.Expanded
			});

			window.localStorage.setItem('ux1SidebarMenuCollapsed', JSON.stringify(this.isMenuCollapsed));
		}
	}
